if (!customElements.get('kustomer-button')) {
  class KustomerButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-kustomer-btn]');
      this.label = this.querySelector('.kustomer-button__label');
      this.offlineText = this.dataset.offlineText;
      this.originalLabel = this.label ? this.label.textContent : '';
      this.checkInterval = null;
      this.kustomerReady = false;
      this.retryCount = 0;
      this.maxRetries = 10;
    }

    connectedCallback() {
      this.waitForKustomer();
    }

    disconnectedCallback() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
      }
    }

    waitForKustomer() {
      // Check if Kustomer is already loaded
      if (typeof window.Kustomer !== 'undefined') {
        this.initializeKustomer();
        return;
      }

      // Poll for Kustomer to load (max 10 seconds)
      let attempts = 0;
      const maxAttempts = 50; // 50 attempts * 200ms = 10 seconds

      this.checkInterval = setInterval(() => {
        attempts++;

        if (typeof window.Kustomer !== 'undefined') {
          clearInterval(this.checkInterval);
          this.initializeKustomer();
        } else if (attempts >= maxAttempts) {
          clearInterval(this.checkInterval);
          // Keep button visible with original label if Kustomer doesn't load
        }
      }, 200);
    }

    initializeKustomer() {
      // Check if isChatAvailable is already available (Kustomer might be fully loaded)
      if (typeof window.Kustomer.isChatAvailable === 'function') {
        this.kustomerReady = true;
        this.checkAvailability();
        return;
      }

      // Wait for Kustomer to fully initialize
      if (typeof window.Kustomer.start === 'function') {
        let callbackFired = false;

        try {
          window.Kustomer.start({}, () => {
            callbackFired = true;
            this.kustomerReady = true;
            this.checkAvailability();
          });

          // Fallback: If callback doesn't fire within 2 seconds, try anyway
          setTimeout(() => {
            if (!callbackFired) {
              if (typeof window.Kustomer.isChatAvailable === 'function') {
                this.kustomerReady = true;
                this.checkAvailability();
              }
            }
          }, 2000);
        } catch (error) {
          this.kustomerReady = true;
          this.checkAvailability();
        }
      } else {
        // Kustomer is already initialized
        this.kustomerReady = true;
        this.checkAvailability();
      }
    }

    checkAvailability() {
      if (!this.kustomerReady || typeof window.Kustomer.isChatAvailable !== 'function') {
        return;
      }

      try {
        const response = window.Kustomer.isChatAvailable();

        if (!response || typeof response.availability === 'undefined') {
          this.retryCount++;

          if (this.retryCount < this.maxRetries) {
            setTimeout(() => this.checkAvailability(), 300);
            return;
          } else {
            this.showButton(this.originalLabel);
            return;
          }
        }

        const availability = response.availability;
        this.handleAvailability(availability);
      } catch (error) {
        this.retryCount++;
        if (this.retryCount < this.maxRetries) {
          setTimeout(() => this.checkAvailability(), 300);
        } else {
          this.showButton(this.originalLabel);
        }
      }
    }

    handleAvailability(availability) {
      // availability can be: 'disabled', 'offline', 'online', 'hidden', 'none'

      if (availability === 'online') {
        // Chat is available - show button with original label
        this.showButton(this.originalLabel);
      } else if (availability === 'offline' || availability === 'hidden') {
        // Chat is offline or hidden
        if (this.offlineText && this.offlineText.trim() !== '') {
          // Show button with offline text
          this.showButton(this.offlineText);
        } else {
          // Hide button if no offline text provided
          this.hideButton();
        }
      } else if (availability === 'disabled') {
        // Chat is disabled
        if (this.offlineText && this.offlineText.trim() !== '') {
          this.showButton(this.offlineText);
        } else {
          this.hideButton();
        }
      } else if (availability === 'none') {
        // Chat appears available even when outside business hours
        this.showButton(this.originalLabel);
      } else {
        // Unknown state - show button with original label
        this.showButton(this.originalLabel);
      }
    }

    showButton(labelText) {
      if (this.button) {
        this.button.style.display = '';
        if (this.label && labelText) {
          this.label.textContent = labelText;
        }
      }
    }

    hideButton() {
      if (this.button) {
        this.button.style.display = 'none';
      }
    }
  }

  customElements.define('kustomer-button', KustomerButton);
}
